import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "color-select"
};
var _hoisted_2 = ["onClick"];
import { ref } from 'vue';

/* 变量 */

export default {
  __name: 'ColorSelect',
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'change'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 工具 */

    var emit = __emit;
    var list = ['#232A35', '#0357E2', '#DE3F3F', '#FFA63A', '#0CB078'];

    /* 事件 */
    var handleClick = function handleClick(color) {
      emit('update:modelValue', color);
      emit('change', color);
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, function (color) {
        return _createElementVNode("div", {
          class: _normalizeClass(["color-item", {
            'color-active': __props.modelValue === color
          }]),
          key: color,
          onClick: function onClick($event) {
            return handleClick(color);
          }
        }, [_createElementVNode("div", {
          style: _normalizeStyle({
            backgroundColor: color
          })
        }, null, 4)], 10, _hoisted_2);
      }), 64))]);
    };
  }
};